import { render, staticRenderFns } from "./MendProdect.vue?vue&type=template&id=3ea9492a&scoped=true&"
import script from "./MendProdect.vue?vue&type=script&lang=js&"
export * from "./MendProdect.vue?vue&type=script&lang=js&"
import style0 from "./MendProdect.vue?vue&type=style&index=0&id=3ea9492a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea9492a",
  null
  
)

export default component.exports